export function isMacPlatform() {
  const platform: string | undefined =
    (navigator as any)?.userAgentData?.platform || navigator?.platform;
  return platform?.toLowerCase().includes('mac') || false;
}
